import React from 'react'
import styled from 'styled-components'

import {NavLink as  Link } from 'react-router-dom'

const Category = (props) => {
  return (
    <Container>
        <NavLink to={props.link} >
          {props.cat}
        </NavLink>
    </Container>
  )
}

const Container = styled.div`
    text-align: center;
    padding: 28px 90px;
    background: #FFFFFF;
    box-shadow: 0px 4px 4px rgba(255, 255, 255, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    font-size: 19px;
    font-weight: 600;
    width: fit-content;

    &:hover{
        padding: 28px 90px;
        transition: all .3s ease-out;
        color: #727171;
    }
`;
const NavLink = styled(Link)`

`

export {Category}